import { authorize, putRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForBackend } from 'services/user/update-details/mapData';

export async function updateUserDetailsAPI(userDetails) {
  const url = `${AWS_API_URL}/user`;
  return putRequest(url, mapDataForBackend(userDetails), await authorize());
}
